// extracted by mini-css-extract-plugin
module.exports = {"placeholderStyle":"Login_placeholderStyle__ZXzn8","inputStyle":"Login_inputStyle__3vqNO"};